/**
 * header.js — نغمة ستور
 * سلوك الهيدر العام: التصاق أعلى الصفحة وتصغيره عند التمرير، فتح/إغلاق
 * بحث الجوال (من زر الهيدر نفسه أو من زر البحث في الشريط السفلي)، الانتقال
 * السريع عبر قائمة "كل الأقسام"، وتحديد وجود شريط التنقل السفلي لإضافة
 * مساحة أسفل الصفحة على الجوال.
 *
 * ملاحظات تصحيح:
 * 1) زر بحث الجوال أصبح يُربط بحثًا شاملاً في كامل الصفحة (document)
 *    وليس فقط داخل عنصر الهيدر، لأن نفس الزر [data-mobile-search-toggle]
 *    قد يظهر أيضًا داخل قسم الشريط السفلي المنفصل (mobile-bottom-nav).
 * 2) مستمع التمرير الخاص بتصغير الهيدر عند اللزوم يُربط مرة واحدة فقط طوال
 *    عمر الصفحة (علم على مستوى الوحدة، لا على مستوى العنصر)، ويعيد البحث
 *    عن عنصر الهيدر الحي في كل استدعاء بدل الاحتفاظ بمرجع قديم قد يُستبدل
 *    عند إعادة تحميل القسم من محرر الثيم — هذا يمنع تراكم مستمعين مكررين.
 * 3) الالتصاق (position: sticky) لم يعد صنفًا CSS ثابتًا على <header>؛
 *    يُضاف صنف "shopify-section--sticky-header" على غلاف القسم
 *    (.shopify-section الأب) ديناميكيًا هنا بناءً على data-sticky، لأن
 *    غلاف القسم من توليد Shopify التلقائي ولا يمكن لـLiquid وضع صنف شرطي
 *    عليه مباشرة (انظر التعليق في component-header.css للسبب الكامل).
 */
(function () {
  "use strict";

  var scrollListenerBound = false;

  function bindReduceOnScrollOnce() {
    if (scrollListenerBound || Naghmah.prefersReducedMotion) return;
    scrollListenerBound = true;

    var onScroll = Naghmah.debounce(function () {
      var header = document.querySelector('[data-section-type="header"]');
      if (!header) return;
      var isSticky = header.dataset.sticky === "true";
      var reduceOnScroll = header.dataset.reduceOnScroll === "true";
      if (!isSticky || !reduceOnScroll) return;
      var shouldReduce = window.scrollY > 40;
      header.classList.toggle("site-header--reduced", shouldReduce);
    }, 50);

    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /**
   * يضيف/يزيل صنف الالتصاق على غلاف القسم (.shopify-section) الأب مباشرة،
   * بدل عنصر الهيدر الداخلي — راجع الملاحظة (3) أعلى الملف. يُستدعى عند كل
   * تهيئة (تحميل أول، وإعادة تحميل من محرر الثيم) لأن الغلاف نفسه عنصر
   * جديد كليًا في كل مرة يُعاد فيها رسم القسم.
   */
  function applyStickyWrapperClass(root) {
    var wrapper = root.closest(".shopify-section");
    if (!wrapper) return;
    var shouldStick = root.dataset.sticky === "true";
    wrapper.classList.toggle("shopify-section--sticky-header", shouldStick);
  }

  function initHeader(root) {
    if (!root || root.dataset.headerInitialized === "true") return;
    root.dataset.headerInitialized = "true";

    applyStickyWrapperClass(root);
    bindReduceOnScrollOnce();

    // مربع "كل الأقسام" داخل البحث: انتقال سريع لصفحة الفئة عند الاختيار
    var categorySelect = root.querySelector("[data-category-jump]");
    if (categorySelect && categorySelect.dataset.categoryJumpBound !== "true") {
      categorySelect.dataset.categoryJumpBound = "true";
      categorySelect.addEventListener("change", function () {
        if (categorySelect.value) {
          window.location.href = categorySelect.value;
        }
      });
    }
  }

  /**
   * زر بحث الجوال قد يوجد في أكثر من قسم (الهيدر نفسه، والشريط السفلي).
   * كل زر يفتح/يغلق شريط بحث الجوال الموجود فعليًا داخل قسم الهيدر
   * (site-header__mobile-search) — لذلك نبحث عن اللوحة عالميًا في كل مرة
   * بدل افتراض وجودها داخل نفس القسم الذي يحوي الزر.
   */
  function initMobileSearchToggles() {
    document.querySelectorAll("[data-mobile-search-toggle]").forEach(function (toggle) {
      if (toggle.dataset.searchToggleBound === "true") return;
      toggle.dataset.searchToggleBound = "true";

      toggle.addEventListener("click", function () {
        var searchPanel = document.querySelector("[data-mobile-search-panel]");
        if (!searchPanel) return;
        var isHidden = searchPanel.hasAttribute("hidden");

        document.querySelectorAll("[data-mobile-search-toggle]").forEach(function (btn) {
          btn.setAttribute("aria-expanded", isHidden ? "true" : "false");
        });

        if (isHidden) {
          searchPanel.removeAttribute("hidden");
          var input = searchPanel.querySelector("input[type='search']");
          if (input) input.focus();
        } else {
          searchPanel.setAttribute("hidden", "");
        }
      });
    });
  }

  function detectBottomNav() {
    var hasBottomNav = !!document.querySelector(".mobile-bottom-nav");
    document.body.setAttribute("data-has-bottom-nav", hasBottomNav ? "true" : "false");
  }

  window.Naghmah = window.Naghmah || {};
  var Naghmah = window.Naghmah;

  if (Naghmah.registerSection) {
    Naghmah.registerSection("header", function (el) {
      initHeader(el);
      initMobileSearchToggles();
      detectBottomNav();
    });
    // قسم الشريط السفلي قد يُعاد تحميله بمفرده في محرر الثيم دون أن يُعاد
    // تحميل قسم الهيدر؛ يجب حينها إعادة ربط زر البحث الجديد فيه، وكذلك
    // تحديث وجود/غياب الشريط نفسه لمساحة أسفل الصفحة.
    Naghmah.registerSection("mobile-bottom-nav", function () {
      initMobileSearchToggles();
      detectBottomNav();
    });
  }

  // إعادة فحص وجود الشريط السفلي أيضًا عند إزالة أي قسم من محرر الثيم
  // (مثال: صاحب المتجر يحذف قسم mobile-bottom-nav بالكامل من الصفحة)،
  // حتى لا تبقى مساحة padding-block-end زائدة في أسفل الصفحة بلا داعٍ.
  document.addEventListener("shopify:section:unload", function () {
    detectBottomNav();
  });

  Naghmah.onReady(function () {
    var header = document.querySelector('[data-section-type="header"]');
    if (header) initHeader(header);
    initMobileSearchToggles();
    detectBottomNav();
  });
})();
